(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bfk-legal"] && !Shopify.designMode) return;
  try {
    (function () {
  function initLegal() {
    const root = document.querySelector('.bfk-legal');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const toc = root.querySelector('.bfk-legal__toc');
    const list = toc.querySelector('ol');
    const headings = [...root.querySelectorAll('.bfk-legal__document h2')];
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = 'bfk-legal-section-' + (index + 1);
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });
    toc.hidden = !headings.length;
    if ('IntersectionObserver' in window && headings.length) {
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          list.querySelectorAll('a').forEach(link => {
            if (link.hash === '#' + entry.target.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        }
      }, { rootMargin: '-100px 0px -60% 0px' });
      headings.forEach(heading => observer.observe(heading));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLegal, { once: true });
  else initLegal();
})();
  } catch(e) { console.error(e); }
})();

})();
